<template>
	<!-- Selected section -->
	<div v-if="selectedItem" class="flex xs-12 bt1 bc7">
		<!-- Details -->
		<div class="xs-12 flex wrap">
			<div class="xs-12 lg-6">
				<div class="x-12 fs3 fw7 pl2 mt2">
					{{
						selectedItem.type === "file"
							? selectedItem.name.includes(".")
								? selectedItem.name
										.split(".")
										.slice(0, -1)
										.join(".")
								: selectedItem.name
							: selectedItem.name
					}}
				</div>
				<div v-if="selectedItem.type === 'file'" class="x-12 fs3 p2">
					{{
						selectedItem.name.includes(".")
							? selectedItem.name.split(".").pop() + " file"
							: "no extension"
					}}
				</div>
				<div v-if="selectedItem.type === 'folder'" class="x-12 fs3 p2">
					{{ $t("folder") }}
				</div>
			</div>
			<div class="xs-12 lg-2">
				<div v-if="selectedItem.type === 'file'" class="x-12 fs3 fw7 pl2 mt2">
					{{ $t("size") }}
				</div>
				<div v-if="selectedItem.type === 'file'" class="x-12 fs3 p2">
					{{ selectedItem.size }}
				</div>
			</div>
			<div class="xs-12 lg-2">
				<div v-if="selectedItem.type === 'file'" class="x-12 fs3 fw7 pl2 mt2">
					{{ $t("privacy_level") }}
				</div>
				<div v-if="selectedItem.type === 'file'" class="x-12 fs3 p2">
					{{ selectedItem.isPublic ? $t("public") : $t("private") }}
				</div>
			</div>
			<div class="xs-12 lg-2">
				<div v-if="selectedItem.type === 'file'" class="x-12 fs3 fw7 pl2 mt2">
					{{ $t("modified") }}
				</div>
				<div v-if="selectedItem.type === 'file'" class="x-12 fs3 p2">
					{{ selectedItem.lastModifiedAt }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import CrmIcon from "@/components/CrmIcon"

export default {
	name: "FileBrowserSelectedSection",

	components: { CrmIcon },

	props: {
		selectedItem: Object
	}
}
</script>
